module.exports = __webpack_public_path__ + "img/logo-GSS.1ea46a99.png";